import {
    logAction,
    RelodeFormikBaseProps,
    useRelodeFormik,
    useRelodeReducer,
    useSnackMiddleware,
} from "@relode/core";
import * as React from "react";

import { AddJobSteps } from "../types";
import { AddJobState, initialAddJobState } from "./addJobState";
import { AddJobActions, addJobReducer, useAddJobActions } from ".";
import { useAddJobErrorHandlers } from "./addJobErrorHandlers";

type IAddJobContext = {
    jobSteps: AddJobSteps;
    state: AddJobState;
    actions: AddJobActions;
} & RelodeFormikBaseProps<AddJobSteps>;

export const AddJobContext = React.createContext<IAddJobContext>(undefined);

export const useAddJobContext = () => {
    const context = React.useContext(AddJobContext);
    if (!context) {
        throw new Error(
            "useAddJobContext must be used within an appropriate provider"
        );
    }
    return context;
};

export const AddJobProvider = (props: { children: React.ReactNode }) => {
    const {
        values: jobSteps,
        formikProps,
        setFieldTouched,
        setFieldValue,
        touchErrors,
    } = useRelodeFormik<AddJobSteps>();

    const [state, dispatch] = useRelodeReducer(
        addJobReducer,
        initialAddJobState,
        [useSnackMiddleware(), logAction]
    );

    const actions = useAddJobActions(dispatch);
    useAddJobErrorHandlers(state, actions);

    const value = {
        state,
        actions,
        jobSteps,
        formikProps,
        setFieldTouched,
        setFieldValue,
        touchErrors,
    } as IAddJobContext;
    return <AddJobContext.Provider value={value} {...props} />;
};
